import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DemarcheItem, DemarcheStep } from '@app/models/demarche';
import { someFromIndex } from '@app/utils/array';

@Component({
  selector: 'app-demarche-question-step',
  templateUrl: './demarche-question-step.component.html',
  styleUrls: ['./demarche-question-step.component.scss'],
  standalone: false
})
export class DemarcheQuestionStepComponent implements OnInit {

  @Input() step: DemarcheStep;
  @Input() demarche: DemarcheItem;
  @Input() index: number;
  @Output() validate = new EventEmitter<number>();
  responseIdValue: number;
  isDisabled: boolean;

  constructor() { }

  ngOnInit(): void {
    if (this.step.idReponse) {
      this.responseIdValue = this.step.idReponse;
      this.isDisabled = this.isQuestionStepsHasEntitySaved() || this.hasLoopQuestionAfter();
    }
  }

  isQuestionStepsHasEntitySaved(): boolean {
    return someFromIndex(
      this.demarche.steps,
      this.index,
      (step, i) => (step.dependentQuestionId === this.step.idQuestion || step.dependenciesQuestion?.includes(this.step.idQuestion)) && typeof step.idEntitySaved === 'number' && !isNaN(step.idEntitySaved)
    )
  }

  hasLoopQuestionAfter(): boolean {
    return someFromIndex(
      this.demarche.steps,
      this.index,
      (step, i) => step.fromLoop && !!step.dependentQuestionId && i !== this.index
    )
  }

  onValidate() {
    this.validate.emit(this.responseIdValue);
  }
}
